import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Badge,
  Box,
  FormControlLabel,
  List,
  ListItem,
  ListItemButton,
  ListItemProps,
  styled,
  Toolbar,
  Typography,
  TypographyProps,
} from '@mui/material'
import React from 'react'

export const StyledBadge = styled(Badge)({
  right: 0,
  width: 22,
  height: 22,
  borderRadius: 15,
  top: '50%',
  padding: '0 2px',
})

export const StyledMenuItem = styled(ListItemButton)(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(1.5, 2, 1.5, 2.25),
  marginBottom: 5,
  transition: 'font-weight 0.2s',
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    width: 4,
    backgroundColor: theme.palette.secondary.main,
    transform: 'scaleY(0)',
    transformOrigin: 'left',
    transition: 'transform 0.3s ease-in-out',
    borderRadius: '0 4px 4px 0',
  },
  '&:hover': {
    backgroundColor: 'transparent',
    '& .MuiListItemIcon-root': {
      opacity: '0.4',
    },
    '& .MuiListItemText-root': {
      opacity: '0.8',
    },
    '& .MuiTypography-body1': {
      opacity: '1',
    },
  },
  '&.Mui-selected': {
    backgroundColor: 'transparent',
    '&::after': {
      transform: 'scaleY(1)',
    },
    '& .MuiListItemIcon-root': {
      opacity: '1',
      color: theme.palette.secondary.main,
    },
    '& .MuiTypography-body1': {
      fontWeight: 'bold',
    },
    '&:hover': {
      backgroundColor: 'transparent',
      '& .MuiListItemIcon-root': {
        opacity: '1',
      },
      '& .MuiListItemText-root': {
        opacity: '1',
      },
    },
  },
}))

export const StyledDrawerInnerCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  overflow: 'auto',
  marginTop: 64,
  [theme.breakpoints.down('xs')]: {
    paddingBottom: theme.spacing(6),
  },
}))

export const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  top: 0,
  padding: theme.spacing(2, 4, 2, 2),
  boxShadow: 'inset 0px -1px 0px rgba(0, 0, 0, 0.1)',
  position: 'fixed',
  backgroundColor: 'white',
  zIndex: 999,
  width: 248,
  cursor: 'pointer',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}))

export const StyledList = styled(List)(({ theme }) => ({
  position: 'relative',
  '& > span': {
    width: '100%',
  },
  '& li': {
    margin: 0,
    padding: theme.spacing(1.75, 2, 1.75, 2.25),
    '&::after': {
      top: '50%',
      bottom: 'auto',
      height: 'calc(100% - 5px)',
      transform: 'translateY(-50%)',
    },
  },
}))

export const StyledCompanySelectWrap = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(4, 0, 3, 0),
  '& .MuiFormControl-root': {
    width: '100%',
    minHeight: 'auto',
  },
  '& .MuiFormHelperText-root': {
    position: 'relative',
    bottom: 5,
    margin: 0,
    paddingLeft: 10,
  },
  [theme.breakpoints.down('sm')]: {
    paddingTop: 0,
  },
}))

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  width: '100%',
  boxShadow: 'none',
  paddingTop: theme.spacing(1),
  '&:before': {
    display: 'none',
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    transform: 'rotate(-90deg)',
    '&.Mui-expanded': {
      transform: 'rotate(-180deg)',
    },
  },
  '& .MuiIconButton-label .MuiSvgIcon-root': {
    color: '#ccc',
  },
  '&.Mui-expanded': {
    backgroundColor: '#F9F9F9',
  },
}))

export const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  flexDirection: 'column',
  padding: theme.spacing(0, 0, 1),
  '& .MuiList-root': {
    padding: 0,
    width: '100%',
  },
}))

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  '&.Mui-expanded': {
    minHeight: theme.spacing(6),
  },
  '& .MuiAccordionSummary-content': {
    alignItems: 'center',
    margin: 0,
    '&.Mui-expanded': {
      margin: 0,
    },
    '& svg': {
      paddingLeft: theme.spacing(0.25),
    },
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0, 2),
  },
}))

export const StyledAccordionSubSummary = styled(AccordionSummary)(({ theme }) => ({
  paddingLeft: theme.spacing(6.625),
  '& .MuiTypography-root': {
    paddingLeft: 0,
  },
  '&:hover': {
    color: '#434343',
    backgroundColor: '#f5f5f5',
  },
  '&.Mui-expanded': {
    minHeight: theme.spacing(6),
  },
  '& .MuiAccordionSummary-content': {
    position: 'relative',
    alignItems: 'center',
    margin: 0,
    '&.Mui-expanded': {
      margin: 0,
    },
    '& svg': {
      paddingLeft: theme.spacing(0.25),
    },
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0, 2),
    '&.MuiAccordionSummary-root': {
      paddingLeft: theme.spacing(6.75),
    },
  },
}))

export const StyledAccordionSubBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  textAlign: 'left',
  fontSize: 16,
  width: 'auto',
  padding: theme.spacing(0.25, 1.65, 0, 0),
  '& .MuiFormHelperText-root': {
    bottom: 0,
    margin: 0,
    position: 'relative',
    padding: 0,
    color: '#999999',
  },
  '& .MuiTypography-root': {
    padding: 0,
  },
}))

export const StyledFormLabel = styled(FormControlLabel)(({ theme }) => ({
  width: '100%',
  justifyContent: 'space-between',
  paddingRight: theme.spacing(3),
  paddingTop: theme.spacing(1),
  paddingLeft: theme.spacing(6.625),
  marginLeft: 0,
}))

export const StyledTypography = styled((props: TypographyProps) => <Typography {...props} />)(
  ({ theme }) => ({
    position: 'relative',
    textAlign: 'left',
    paddingLeft: theme.spacing(1.5),
    fontSize: 16,
    lineHeight: 1.5,
    width: '90%',
    '& .MuiFormHelperText-root': {
      bottom: 0,
      margin: 0,
      position: 'relative',
      paddingLeft: 0,
      color: '#999999',
    },
    '& > span': {
      right: theme.spacing(-1.5),
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(1.875),
    },
  }),
)

interface StyledListItemProps extends ListItemProps {
  active?: boolean
}
export const StyledListItem = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== 'active',
})<StyledListItemProps>(({ theme, active }) => ({
  position: 'relative',
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  rowGap: 0,
  justifyContent: 'space-between',
  padding: theme.spacing(1, 2, 1, 6.625),
  '& .flag-icon-lg': {
    fontSize: '1.5em',
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1, 1, 1, 6.75),
  },
  '& .MuiTypography-root': {
    fontWeight: active ? 700 : 'normal',
  },
  '&:hover': {
    cursor: 'pointer',
    color: '#434343',
    backgroundColor: '#f5f5f5',
  },
  '&::before': active
    ? {
        content: '""',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        width: theme.spacing(0.5),
        backgroundColor: '#EF2828',
      }
    : {},
}))

export const StyledItem = styled(Typography)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  rowGap: 0,
  justifyContent: 'space-between',
  padding: theme.spacing(1, 2, 1, 6.625),
  '& .flag-icon-lg': {
    fontSize: '1.5em',
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1, 1, 1, 6.75),
  },
}))

export const StyledCompanyName = styled(Typography)(({ theme }) => ({
  position: 'relative',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  height: theme.spacing(4),
  lineHeight: '2rem',
  paddingRight: theme.spacing(1.65),
}))
